<template>
    <div class="w-75 meeting-invite">
        <div class="appt-section-title">Meeting Invite*</div>
        <Input
            label=""
            labelClass="add-new-app-label"
            type="text"
            class="field-container d-flex align-items-center mb-4"
            name="Meeting Invite"
            rules="ValidateUrl"
            placeholder="Enter Meeting Invite"
            :value="meetingLink"
            @input="updateMeetingLink"
            required
        />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'MeetingLink',
        computed: {
            ...mapState('eventEditor', {
                meetingLink: (state) => state.event.meeting_link,
            }),
        },
        methods: {
            ...mapActions('eventEditor', {
                updateMeetingLink: 'updateMeetingLink',
            }),
        },
    };
</script>
